import { useState } from 'react';
import { supabase } from '../lib/supabase';
import {
  Form,
  Button,
  Alert,
  Container,
  Row,
  Col,
  Card,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from '../assets/LogoNavbar.png';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    setLoading(false);

    if (error) {
      setError(error.message);
    } else {
      setSubmitted(true);
    }
  };

  return (
    <div className="bg-light min-vh-100 d-flex align-items-center">
      <Container className="py-5">
        <Card className="shadow-lg rounded-3 overflow-hidden">
          <Row className="g-0">
            <Col
              md={6}
              className="bg-primary text-white p-4 d-flex flex-column justify-content-center align-items-center text-center"
            >
              <div>
                <img
                  src={logo}
                  alt="SupplyPassport Logo"
                  height="80"
                  className="mb-4"
                />
                <h2 className="fw-bold">Reset your password</h2>
                <p className="mt-3 mb-0">
                  We'll send you a link to get back into your account.
                </p>
              </div>
            </Col>

            <Col md={6} className="bg-white p-4">
              <div className="mb-4">
                <h2 className="h4 fw-bold mb-1">Forgot password?</h2>
              </div>

              {submitted ? (
                <Alert variant="success">
                  Check your inbox — if an account exists for{' '}
                  <strong>{email}</strong>, a reset link is on its way.
                </Alert>
              ) : (
                <>
                  {error && <Alert variant="danger">{error}</Alert>}
                  <Form onSubmit={handleSubmit} className="mb-3">
                    <Form.Group className="mb-3" controlId="formEmail">
                      <Form.Label className="small">Email address</Form.Label>
                      <div className="input-group">
                        <span className="input-group-text bg-white border-end-0">
                          <i className="bi bi-envelope" />
                        </span>
                        <Form.Control
                          type="email"
                          placeholder="you@company.com"
                          className="border-start-0"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          autoFocus
                        />
                      </div>
                    </Form.Group>

                    <Button
                      type="submit"
                      className="w-100 btn-primary my-4"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send reset link'}
                    </Button>
                  </Form>
                </>
              )}

              <p className="text-center small mt-4 mb-0">
                Remembered it?{' '}
                <Link to="/login" className="fw-semibold">
                  Back to sign in
                </Link>
              </p>
            </Col>
          </Row>
        </Card>
      </Container>
    </div>
  );
}
